import React, { Component } from 'react';
import LoadingBar from '../../components/global/loadingBar';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import InputHeader from '../../components/global/inputwithHeader';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import _ from 'lodash';
import Select from 'react-select';
import equipmentConstants from '../../../utils/equipmentConstants';
var randomize = require('randomatic');
const getBranchList = gql`
	query BranchesList {
		branchesList {
			id
			code
			branchId
			description
			address
			city
			state
		}
	}
`;
const registerAsset = gql`
	mutation RegisterAsset($assetInput: RegisterAssetInput!, $branchId: String) {
		registerAsset(assetInput: $assetInput, branchId: $branchId) {
			id
			qrCode
			serialNumber
			status
			type
		}
	}
`;
class RegisterAsset extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			assetType: '',
			qrCode: '',
			serialNumber: '',
			description: '',
			isAPISubmitting: false,
			selectedassetType: {},
			branchesListOption: [],
			selectedbranchString: {},
			selectedmanufacturer: {},
			selectedstoragesize: {},
			branchString: '',
			storageSizeOptions: equipmentConstants.asset.storageSizes,
			manufacturerOptions: equipmentConstants.asset.manufacturers,
			assetTypeOptions: equipmentConstants.asset.types,
		};
	}
	componentDidMount = () => {
		this.getBranchList(getBranchList);
	};
	isButtonDisabled = () => {
		const { assetType, serialNumber, branchString } = this.state;

		// Function to check if a number is valid

		// Perform the necessary conditions to determine if the button should be disabled
		const isDisabled =
			assetType === null ||
			assetType.length === 0 ||
			serialNumber === null ||
			serialNumber.length === 0 ||
			(this.state.selectedassetType.value === 'harddrive' &&
				!this.state.selectedmanufacturer?.label) ||
			(this.state.selectedassetType.value === 'harddrive' &&
				!this.state.selectedstoragesize?.label);

		return isDisabled;
	};
	registerAssetAPICall = () => {
		if (this.state.isAPISubmitting === false) {
			this.setState(
				{
					isAPISubmitting: true,
					errorMessage: '',
				},
				() => {
					if (this.state.serialNumber === '') {
						this.setState({
							errorMessage: 'Serial Number is Mandatory',
							isAPISubmitting: false,
						});
					} else if (this.state.assetType === '') {
						this.setState({
							errorMessage: 'Asset Type is Mandatory',
							isAPISubmitting: false,
						});
					} else if (this.state.qrCode !== '' && this.state.qrCode.length !== 8) {
						this.setState({ errorMessage: 'Invalid QR Code', isAPISubmitting: false });
					} else {
						let json = {
							assetInput: {
								serialNumber: this.state.serialNumber,
								type: this.state.assetType,
							},
							// branchId: this.state.branchString,
						};
						if (
							this.state.branchString !== null &&
							this.state.branchString.length > 0
						) {
							json = {
								...json,
								branchId: this.state.branchString,
							};
						}
						if (this.state.qrCode !== '') {
							json = {
								...json,
								assetInput: {
									...json.assetInput,
									qrCode: this.state.qrCode,
								},
							};
						}
						if (this.state.description.length > 0) {
							json = {
								...json,
								assetInput: {
									...json.assetInput,
									description: this.state.description,
								},
							};
						}
						if (
							this.state.selectedassetType.value === 'harddrive' &&
							this.state.selectedmanufacturer.label.length > 0 &&
							this.state.selectedstoragesize.label.length > 0
						) {
							json = {
								...json,
								assetInput: {
									...json.assetInput,
									metaData: {
										size: this.state.selectedstoragesize.label,
										manufacturer: this.state.selectedmanufacturer.label,
									},
								},
							};
						}

						this.registerAsset(registerAsset, json);
					}
				},
			);
		}
	};

	saveInput = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
			errorMessage: '',
		});
	};

	saveSelectDropDown = (e, name) => {
		this.setState({
			[name]: e.value,
			[`selected${name}`]: e,
			errorMessage: '',
		});
	};

	render() {
		return (
			<div className="assign-receive-container" style={{ width: '100%', marginLeft: 0 }}>
				<div className="arc-header">
					<div className="back-btn" onClick={() => this.props.navigate(-1)}>
						<Back />
					</div>
					<div className="arch-item">
						<span>Admin Tools</span>
					</div>
					<div className="next-btn">
						{' '}
						<Back />
					</div>

					<div className="arch-item">
						<span>Register Asset</span>
					</div>
					<div className="actn-btn">
						<a
							onClick={(e) => {
								if (!this.isButtonDisabled()) {
									this.registerAssetAPICall();
								} else {
									this.setState({
										errorMessage: 'Please fill all the required details',
									});
								}
							}}
							className={this.isButtonDisabled() ? 'isDisabledBtn' : ''}
						>
							Register Assets
						</a>
					</div>
				</div>
				<div className="arc-body" style={{ width: '40%' }}>
					<div className="remap-equipment-container">
						<div className="rec-left">
							<div
								className="floating-select-container"
								style={{ marginBottom: '16px' }}
							>
								<label>
									Asset Type
									<span className="required-star">*</span>
								</label>

								<Select
									value={this.state.selectedassetType}
									className="cost-select-container updiv"
									classNamePrefix="cost-select"
									options={this.state.assetTypeOptions}
									name={'assetType'}
									onChange={(e) => {
										this.saveSelectDropDown(e, 'assetType');
									}}
									menuPortalTarget={document.body}
									menuPosition={'fixed'}
								/>
							</div>
							<div
								className="floating-select-container"
								style={{ marginBottom: '16px', marginTop: '16px' }}
							>
								<label>
									Branch
									<span className="required-star"></span>
								</label>
								<Select
									value={this.state.selectedbranchString}
									className={
										'cost-select-container lowdiv' +
										(this.state.isSuspended ? ' cost-select--is-disabled' : '')
									}
									classNamePrefix="cost-select"
									options={this.state.branchesListOption}
									name={'branchString'}
									onChange={(e) => {
										this.saveSelectDropDown(e, 'branchString');
									}}
									menuPortalTarget={document.body}
									menuPosition={'fixed'}
								/>
							</div>
							<input
								style={{ marginBottom: '16px' }}
								className="qrcode"
								value={this.state.qrCode}
								placeholder="Type QR Code"
								name={'qrCode'}
								onChange={(e) => this.saveInput(e)}
							/>

							<input
								style={{ marginBottom: '16px' }}
								className="qrcode"
								value={this.state.serialNumber}
								placeholder="Type Serial Number*"
								name={'serialNumber'}
								onChange={(e) => this.saveInput(e)}
							/>
							<input
								style={{ marginBottom: '16px' }}
								className="qrcode"
								value={this.state.description}
								placeholder="Type Description"
								name={'description'}
								onChange={(e) => this.saveInput(e)}
							/>

							<p style={{ color: 'red', fontSize: '10px' }}>
								{this.state.errorMessage}
							</p>
							{this.state.selectedassetType.value === 'harddrive' && (
								<>
									<div
										className="floating-select-container"
										style={{
											marginBottom: '16px',
											marginTop: '16px',
											textTransform: 'none',
										}}
									>
										<label>
											Manufacturer*
											<span className="required-star"></span>
										</label>
										<Select
											value={this.state.selectedmanufacturer}
											className={
												'cost-select-container lowdiv' +
												(this.state.isSuspended
													? ' cost-select--is-disabled'
													: '')
											}
											classNamePrefix="cost-select"
											options={this.state.manufacturerOptions}
											name={'manufacturer'}
											onChange={(e) => {
												this.saveSelectDropDown(e, 'manufacturer');
											}}
											menuPortalTarget={document.body}
											menuPosition={'fixed'}
										/>
									</div>
									<div
										className="floating-select-container"
										style={{
											marginBottom: '16px',
											marginTop: '16px',
											textTransform: 'none',
										}}
									>
										<label>
											Storage Size*
											<span className="required-star"></span>
										</label>
										<Select
											value={this.state.selectedstoragesize}
											className={
												'cost-select-container lowdiv' +
												(this.state.isSuspended
													? ' cost-select--is-disabled'
													: '')
											}
											classNamePrefix="cost-select"
											options={this.state.storageSizeOptions}
											name={'storagesize'}
											onChange={(e) => {
												this.saveSelectDropDown(e, 'storagesize');
											}}
											menuPortalTarget={document.body}
											menuPosition={'fixed'}
										/>
									</div>
								</>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default withRouter(RegisterAsset);
